// AAD_LOGIN_SUCCESS and AAD_LOGOUT_SUCCESS and defined in the msal library
export const AAD_LOGIN_SUCCESS = "AAD_LOGIN_SUCCESS";
export const AAD_ACQUIRED_ID_TOKEN_SUCCESS = "AAD_ACQUIRED_ID_TOKEN_SUCCESS";
